import React, { Fragment, useEffect, useState } from 'react';
import { Table, Modal, Button, Tag, message } from 'antd';
import { PlusOutlined, SettingTwoTone, ExclamationCircleOutlined, EditOutlined, DeleteOutlined, AppstoreAddOutlined, NodeIndexOutlined } from '@ant-design/icons';
import {request} from '@/utils/useRequest';
import useWscCustomFormModal from '@/component/UseWscCustomForm';
import useWscCustomColumns from '@/component/UseWscCustomColumns';
import ColumnSettings from '@/component/ColumnSettings';
import _ from 'lodash';
import { useCommonStore } from '@/store/useCommonStore';
import { createStoreWithImmerAndLogger } from '@/store/base';


const { confirm } = Modal;

const initState = {
  list: [],
  loading: false,
};

const usePageStore = createStoreWithImmerAndLogger((set, get) => ({
  ...initState,
  toTree: () => {
    let menus = _.cloneDeep(useCommonStore.getState().menus);

    let parent2Children = menus.reduce((acc, item) => {
      const key = item.ParentId === null || item.ParentId === undefined ? 'root' : item.ParentId;
      const children = acc[key] ?? [];
      children.push({ ...item, key: item.Id });
      return { ...acc, [key]: children };
    }, {});
    Object.keys(parent2Children).forEach(key => {
      const children = parent2Children[key].sort((a, b) => a.SortNum - b.SortNum);
      parent2Children[key] = children;
    });

    Object.entries(parent2Children).forEach(([key, children]) => {
      children.forEach(item => item.children = parent2Children[item.Id]);
    })
    console.log(parent2Children);
    const { root } = parent2Children;
    console.log(root);
    set(state => { state.list = root });
  }
}))
const MgrMenuList = (props) => {
  const { list, loading, toTree } = usePageStore();
  const getCommMenu = useCommonStore.use.getMenu();
  const getMenu = async () => {
    await getCommMenu();
    toTree();
  };

  const { showDynamicModal, hide, WscCustomFormModal } = useWscCustomFormModal();
  const { Refresh: refreshColumns, colsettings } = useWscCustomColumns({ key: "menulist" });
  const [columns, setColumns] = useState([]);

  useEffect(() => {
    toTree();
    if (colsettings) {
      let cols = colsettings?.filter(item => item.visible).concat(ExtendColumns);
      let col = cols.find(item => item.dataIndex == "FuncInfos");
      if (col) {
        col.render = (funcs) => {
          // 确保funcs是一个数组，如果不是，则将其转换为数组
          const funcArray = Array.isArray(funcs) ? funcs : [];
          return (
            <div>
              {funcArray.map((item, index) => {
                return (
                  <Tag
                    key={index}
                    closable={true}
                    onClose={async (e) => {
                      e.preventDefault();
                      let decide = confirm({ content: `你确定要删除【${item.FuncName}】功能资源配置吗?` });
                      if (decide) {
                        console.log("request:", request);
                        let result = await request("/api/v2/private/funcinfo/delete", "POST", "json", { id: item.Id });
                        if (result.success) {
                          //刷新列表
                          getMenu();
                        }
                      }
                      return false;
                    }}
                  >
                    {item.FuncName}({item.Id})
                  </Tag>
                );
              })}
            </div>
          );
        };
        //setColumns(cols);
      }
      setColumns(cols);
    }
  }, [colsettings]);

  const ExtendColumns = [
    {
      title: (
        <div>
          操作 <ColumnSettings topic="menulist" colsettings={colsettings} list={list} onFinish={refreshColumns} />
        </div>
      ),
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => {
        return (
          <Fragment>
            <Button type="link" icon={<AppstoreAddOutlined />} title="添加功能" onClick={() => showDynamicModal(124, { MenuName: record.Name, MenuId: record.Id })} />

            <Button type="link" icon={<EditOutlined />} title="修改菜单" onClick={() => showDynamicModal(52, record)} />
            <Button type="link" icon={<NodeIndexOutlined />} title="添加平级节点" onClick={() => showDynamicModal(56, { ParentId: record.ParentId })} />
            <Button type="link" icon={<PlusOutlined />} title="添加子节点" onClick={() => showDynamicModal(56, { ParentId: record.Id })} />
            <Button
              type='link'
              icon={<DeleteOutlined />}
              title="删除"
              onClick={async () => {
                confirm({
                  title: '确认删除',
                  icon: <ExclamationCircleOutlined />,
                  content: '您确定删除此菜单么？',
                  onOk: async () => {
                    try {
                      let result = await request("/api/v2/private/menu/delete", "POST", "json", { id: record.Id });
                      if (result.success) {
                        message.success(result.message);
                        getMenu();
                      } else {
                        Modal.error({ content: result.message });
                      }
                    } catch (error) {
                      Modal.error({ content: '请求出错，请稍后重试' });
                    }
                  },
                  okText: '确认',
                  cancelText: '取消',
                });
              }}
            />
          </Fragment>
        );
      },
    },
  ];

  return (
    <div className="p-4 max-h-[calc(100vh-5.25rem)] overflow-y-auto">
      <div className="">
        <Table columns={columns} size="small" loading={loading} pagination={false} dataSource={list} />
      </div>
      <WscCustomFormModal
        formId={124}
        OnPayload={(form, name, payload) => {
          if (name == "Cancel") {
            hide(124);
          }
          if (name == "OK") {
            if (payload.apiresult?.success == false) {
              Modal.error({ content: payload.apiresult.message });
              return;
            } else {
              message.success(payload.apiresult?.message);
              getMenu();
              hide(124);
              return;
            }
          }
        }}
      />

      <WscCustomFormModal
        formId={52}
        OnPayload={(form, name, payload) => {
          if (name == "Cancel") {
            hide(52);
          }
          if (name == "OK") {
            if (payload.apiresult?.success == false) {
              Modal.error({ content: payload.apiresult.message });
              return;
            } else {
              message.success(payload.apiresult?.message);
              getMenu();
              hide(52);
              //Refresh();
              return;
            }
          }
        }}
      />

      <WscCustomFormModal
        formId={56}
        OnPayload={(form, name, payload) => {
          if (name == "Cancel") {
            hide(56);
          }
          if (name == "OK") {
            if (payload.apiresult?.success == false) {
              Modal.error({ content: payload.apiresult.message });
              return;
            } else {
              message.success(payload.apiresult?.message);
              getMenu();
              hide(56);
              //Refresh();
              return;
            }
          }
        }}
      />
    </div>
  );
};

export default MgrMenuList;